exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-orange {\n  color: #FF7000;\n  font-weight: 900; }\n\n.center {\n  padding-top: 17%; }\n\n.size {\n  width: 60%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/juegos/components/verification/email-success.scss
// module id = ../../../../../src/app/juegos/components/verification/email-success.scss
// module chunks = 6